export type ServiceInstanceBrief = {
  id?: string | number | null
  instance_id?: string | null
  name?: string | null
}

export function formatServiceInstanceLabel(ref?: ServiceInstanceBrief | null): string | null {
  if (!ref) {
    return null
  }

  const name = String(ref.name ?? '').trim()
  const code = String(ref.instance_id ?? ref.id ?? '').trim()

  if (name && code) {
    return `${name} (${code})`
  }

  return name || code || null
}

export function getServiceInstanceNavigationId(ref?: ServiceInstanceBrief | null): string | null {
  if (!ref) {
    return null
  }

  const instanceId = String(ref.instance_id ?? '').trim()
  if (instanceId) {
    return instanceId
  }

  if (ref.id != null) {
    const pk = String(ref.id).trim()
    if (pk) {
      return pk
    }
  }

  return null
}

export function resolveJobNavigationServiceInstanceId({
  contractContext,
  jobServiceInstanceId,
  jobsSummary,
  bookingServiceInstanceId,
}: {
  contractContext?: Record<string, unknown> | null
  jobServiceInstanceId?: string | number | null
  jobsSummary?: Array<{ service_instance_id?: string | null }>
  bookingServiceInstanceId?: string | number | null
}): string | null {
  const fromContract = contractContext?.job_service_instance as ServiceInstanceBrief | undefined
  const fromContractId = getServiceInstanceNavigationId(fromContract)
  if (fromContractId) {
    return fromContractId
  }

  if (jobServiceInstanceId != null) {
    const trimmed = String(jobServiceInstanceId).trim()
    if (trimmed) {
      return trimmed
    }
  }

  for (const job of jobsSummary ?? []) {
    const jobInstanceId = String(job.service_instance_id ?? '').trim()
    if (jobInstanceId) {
      return jobInstanceId
    }
  }

  if (bookingServiceInstanceId != null) {
    const trimmed = String(bookingServiceInstanceId).trim()
    if (trimmed) {
      return trimmed
    }
  }

  return null
}
